import { Component, ElementRef, EventEmitter, Output, ViewChild, AfterViewInit } from '@angular/core';
import SignaturePad from 'signature_pad';
import { NzModalRef } from 'ng-zorro-antd/modal';

@Component({
  selector: 'app-signature-modal',
  templateUrl: './signature-modal.component.html',
  styleUrl: './signature-modal.component.css'
})
export class SignatureModalComponent implements AfterViewInit {
  @ViewChild('canvas', { static: true }) canvasRef!: ElementRef<HTMLCanvasElement>;
  private signaturePad!: SignaturePad;

  @Output() signatureSaved = new EventEmitter<string>();

  constructor(private modalRef: NzModalRef) {}

  ngAfterViewInit() {
    const c = this.canvasRef.nativeElement;
    this.signaturePad = new SignaturePad(c, {
      backgroundColor: 'rgb(211, 211, 211)'
    })
  }

  clear() {
    this.signaturePad.clear()
  }

  save() {
    this.modalRef.close(this.signaturePad.toDataURL());
  }

}
